module.exports = __webpack_public_path__ + "static/media/signature.628e9cd9.svg";